import _ from 'lodash';
var Collection = /** @class */ (function () {
    function Collection(items) {
        if (items === void 0) { items = []; }
        this.items = items;
    }
    Object.defineProperty(Collection.prototype, "lodash", {
        get: function () {
            return _.chain(this.items);
        },
        enumerable: true,
        configurable: true
    });
    Collection.prototype.all = function () {
        return this.items;
    };
    Collection.prototype.get = function (index) {
        return this.items[index];
    };
    Collection.prototype.first = function () {
        return this.items[0];
    };
    Collection.prototype.last = function () {
        return this.items[this.items.length - 1];
    };
    Collection.prototype.add = function (item, index) {
        if (index !== undefined) {
            this.items.splice(index, 0, item);
        }
        else {
            this.items.push(item);
        }
    };
    Collection.prototype.addAll = function (list, index) {
        var _a, _b;
        if (index !== undefined) {
            (_a = this.items).splice.apply(_a, [index, 0].concat(list));
        }
        else {
            (_b = this.items).push.apply(_b, list);
        }
    };
    Collection.prototype.remove = function (item) {
        var index = this.items.indexOf(item);
        if (index >= 0) {
            this.items.splice(index, 1);
        }
    };
    Collection.prototype.size = function () {
        return this.items.length;
    };
    Collection.prototype.isEmpty = function () {
        return !this.items.length;
    };
    Collection.prototype.isNotEmpty = function () {
        return !!this.items.length;
    };
    Collection.prototype.clear = function () {
        this.items = [];
    };
    return Collection;
}());
export { Collection };
//# sourceMappingURL=Collection.js.map